import { configureStore, combineReducers } from "@reduxjs/toolkit";

import SiteSummary from "./SiteSummary/siteSummary.store";
import GroupSitesAssets from "./groupSitesAssets/groupSitesAssets.store";

const rootReducer = combineReducers({
  SiteSummary: SiteSummary.reducer,
  GroupSitesAssets: GroupSitesAssets.reducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof rootReducer>;

export default store;
